import { Link, navigate } from "gatsby";
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Carousel from "react-bootstrap/Carousel";
import Dropdown from "react-bootstrap/Dropdown";
import IGuestProfile from "../../../@types/IGuestProfile";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import useAuthenticate from "../../../hooks/useAuthenticate";
import { logout } from "../../../redux/slices/Member/member";
import EmailSentComponent from "../LoginForm/EmailSent";
import { ForgotPasswordForm } from "../LoginForm/ForgotPasswordOptions";
import {
  DropdownLoginForm,
  ModalHeader,
  Profile,
  ProfileModal,
  StyledDropdown,
} from "./SignInBarHelpers";
import { ISignInBarProps } from "./SignInBarProps";

const SignInBar: React.FC<ISignInBarProps> = (props) => {
  const path = props.location.pathname.split("/");
  const isCheckout = path[1] === "checkout";
  const isAuthenticated = useAuthenticate(props.showDropdown);
  const dispatch = useAppDispatch();
  const member = useAppSelector((state) => state.member);
  const [showProfileModal, setShowProfileModal] = React.useState(false);
  const [isSignInModal, setSignInModal] = useState(false);
  const profile: IGuestProfile =
    member.crmBasicProfile &&
    typeof member.crmBasicProfile === "object" &&
    Object.keys(member.crmBasicProfile).length
      ? (member.crmBasicProfile as IGuestProfile)
      : (member.profile as IGuestProfile);
  const firstName = profile?.firstName || "";
  const authenticated = member.isLoggedIn && isAuthenticated;
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [emailMessage, setEmailMessage] = useState("");
  const toggleText =
    member.isLoggedIn && isAuthenticated
      ? `<span class="toggle-text">${firstName}</span>`
      : `Sign In or Join`;
  const memberPoints = new Intl.NumberFormat("en-US").format(
    member?.memberPointsTally || 0
  );

  const handleDropdown = () => {
    props.setShowDropdown(!props.showDropdown);
    setCarouselIndex(0);
  };

  const handleSignInModal = () => {
    handleDropdown();
    setSignInModal(!isSignInModal);
  };
  const onHideModal = () => {
    setSignInModal(false);
    setCarouselIndex(0);
  };
  const handleSignin = () => {
    props.setShowDropdown(false);
    onHideModal();
  };

  const handleSignout = async () => {
    props.setShowDropdown(false);
    onHideModal();
    dispatch(logout());
  };

  const handleMyAccount = (e: any) => {
    if (isCheckout) {
      setShowProfileModal(true);
      e.preventDefault();
      return false;
    } else {
      navigate("/account");
    }
  };

  const handleHideProfileModal = () => {
    setShowProfileModal(false);
    handleDropdown();
  };

  const handleBackToLogin = () => {
    setTimeout(() => {
      setCarouselIndex(0);
    }, 100);
  };
  const handleForgotPassword = () => {
    setTimeout(() => {
      setCarouselIndex(1);
    }, 100);
  };

  const handleEmailSent = (message: string) => {
    setTimeout(() => {
      setEmailMessage(message);
      setCarouselIndex(2);
    }, 100);
  };

  useEffect(() => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.focus();
      document.activeElement.blur();
    }
  }, [carouselIndex]);

  useEffect(() => {
    if (!isSignInModal) {
      setCarouselIndex(0);
      setEmailMessage("");
    }
  }, [isSignInModal]);

  const handleSelect = (selectedIndex: number) => {
    setCarouselIndex(selectedIndex);
  };

  return (
    <StyledDropdown show={props.showDropdown} onToggle={handleDropdown}>
      <Dropdown.Toggle className="dropdownBtn" onClick={handleSignInModal}>
        <span
          id="login-user-name"
          dangerouslySetInnerHTML={{ __html: toggleText }}
        ></span>
      </Dropdown.Toggle>
      <Dropdown.Menu className={authenticated ? "in-account-view" : ""}>
        <div className="inner signInBar">
          {!authenticated ? (
            <Carousel
              activeIndex={carouselIndex}
              onSelect={handleSelect}
              controls={false}
              indicators={false}
              interval={null}
              touch={false}
            >
              <Carousel.Item className="carousel-item">
                {carouselIndex === 0 && (
                  <DropdownLoginForm
                    location={props.location}
                    onSignIn={handleSignin}
                    controlColSize={12}
                    onSignUpLoad={handleDropdown}
                    onForgotPassword={handleForgotPassword}
                    onCloseClick={handleDropdown}
                  />
                )}
              </Carousel.Item>
              <Carousel.Item className="carousel-item">
                {carouselIndex === 1 && (
                  <ForgotPasswordForm
                    location={props.location}
                    onEmailSent={handleEmailSent}
                    onBackToLogin={handleBackToLogin}
                    onCloseClick={handleDropdown}
                  />
                )}
              </Carousel.Item>
              <Carousel.Item className="carousel-item">
                {carouselIndex === 2 && emailMessage && (
                  <EmailSentComponent
                    message={emailMessage}
                    onCloseClick={handleDropdown}
                  />
                )}
              </Carousel.Item>
            </Carousel>
          ) : (
            <>
              <ModalHeader onCloseClick={handleDropdown} />
              <div className="account-details-container">
                <div className="account-details">
                  <div className="account-name">
                    {" "}
                    Hello, {profile?.firstName}
                  </div>
                  <div className="account-point">
                    <span> Travel Pass Points </span>
                    <span> {memberPoints} points</span>
                  </div>
                  <div className="account-status">
                    <span> Status </span>
                    <span> {profile?.profileType}</span>{" "}
                  </div>
                </div>
                <Profile>
                  <Link
                    id="view-my-account"
                    to={"/account"}
                    className={`profile-link`}
                    onClick={handleMyAccount}
                  >
                    View my account
                  </Link>
                  <Button
                    id="sign-out-account"
                    onClick={handleSignout}
                    variant="link"
                    size="sm"
                  >
                    Sign out
                  </Button>
                </Profile>
                {showProfileModal && (
                  <ProfileModal
                    show={showProfileModal}
                    onHide={handleHideProfileModal}
                  />
                )}
              </div>
            </>
          )}
        </div>
      </Dropdown.Menu>
    </StyledDropdown>
  );
};

export default SignInBar;
